import { DeployBotState } from './types'
import { RootState } from '../../reducers'

export function getDeployErrorSelector(state: RootState): string | undefined {
  return state?.deployBot?.deployError
}

export function possibleResumeHostingForBotIdSelector(state: RootState, botId: string): boolean {
  return (state.deployBot as DeployBotState).botIdsForPossibleResumeHosting.some(
    currentBotId => currentBotId === botId
  )
}
